import gql from 'graphql-tag';

export const CreateLostAndFoundIssue = gql`
  mutation CreateLostAndFoundIssueBulk($input: CreateLostAndFoundIssueBulkInput!) {
    createLostAndFoundIssueBulk(input: $input) {
      output {
        error
        output {
          issue {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            itemLost
            crewMemberName
            crewMemberPhone
            crewMemberEmail
            description
            outboundDatetime
            tripId
            driverId
            dispatcherId
            notes
            outboundFlightNumber
            shippingAddress
            shippingStateCode
            shippingCity
            returnStatus
            shippingCost
            shippingZipCode
            shippingMethod
            trackingNumber
            vehicleId
            datetime
            deletedAt
            deletedBy
            traceId
            crewFlightNumber
            crewAirportCode
            crewDriverName
            crewFlightName
            outboundFlightName
          }
          document {
            document {
              id
              createdAt
              createdBy
              updatedAt
              updatedBy
              issueId
              filename
              fileLocation
              contentType
              fileSize
              md5
              deletedAt
              deletedBy
              traceId
            }
            presignedUrl
          }
        }
      }
    }
  }
`;
